export const SITE_NAME = 'Family Tree Maker Contact';
export const SITE_DOMAIN = 'familytreemakercontact.online';
export const SITE_URL = 'https://www.familytreemakercontact.online';
export const SITE_TAGLINE = 'Independent help for your family history software';
export const COMPANY_NAME = 'Nodex Global LLC';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS = `${ADDRESS_LINE1}, ${ADDRESS_LINE2}`;
export const POLICY_UPDATED = 'October 1, 2026';
export const META_DESCRIPTION =
  'Independent Family Tree Maker support — installation, activation, FamilySync, TreeVault, missing media, and upgrades for Windows and Mac, with live chat around the clock.';

/**
 * No phone number is published on this site for now.
 * To show one later, set e.g. { display: '(800) 000-0000', tel: 'tel:+18000000000' }
 * and the call buttons will appear automatically next to Live Chat.
 */
export const SUPPORT_PHONE = null;

export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_a9df6a45537a524d1ea5805a68f7116a3bb38370f4de2c69';
export const LEAD_SOURCE = 'tree16';

/** Used in the legal pages so they describe the right software and trademark owners. */
export const PRODUCT_NAME = 'Family Tree Maker';
export const TRADEMARK_OWNERS = 'Software MacKiev, Ancestry, FamilySearch';
